// @flow
import SidebarFooter from './SidebarFooter';

export default SidebarFooter;
